import React from 'react';
import { Brain, Sparkles, Target, TrendingUp, AlertCircle } from 'lucide-react';

const insights = [
  {
    type: 'success',
    icon: TrendingUp,
    title: 'Sisällön näkyvyys parantunut',
    description: '"Kahvin valmistus" AI-yhteenvedoissa',
    impact: '+15% liikennettä',
  },
  {
    type: 'suggestion',
    icon: Brain,
    title: 'AI-ystävällisyys',
    description: 'Optimoi "kahvikone arvostelu" sisältöä',
    impact: 'Potentiaali +200 mainintaa',
  },
  {
    type: 'warning',
    icon: AlertCircle,
    title: 'Kilpailijan-suosituksia',
    description: 'Kilpailijan suosituksia kohdesanoissasi',
    impact: 'Seuranta suositeltu',
  },
];

const typeStyles: { [key: string]: string } = {
  success: 'from-green-500/20 to-green-600/20 border-green-500/30 text-green-400',
  suggestion: 'from-purple-500/20 to-purple-600/20 border-purple-500/30 text-purple-400',
  warning: 'from-orange-500/20 to-orange-600/20 border-orange-500/30 text-orange-400',
};

export default function AIInsights() {
  return (
    <div className="bg-slate-800/50 backdrop-blur-xl rounded-xl p-6 border border-slate-700/50">
      <div className="flex items-center space-x-2 mb-6">
        <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center">
          <Sparkles className="w-4 h-4 text-white" />
        </div>
        <div>
          <h3 className="text-lg font-bold text-white">AI-huomiot</h3>
          <p className="text-xs text-slate-400">Reaaliaikaiset suositukset</p>
        </div>
      </div>

      <div className="space-y-4">
        {insights.map((insight, index) => {
          const Icon = insight.icon;
          
          return (
            <div
              key={index}
              className={`p-4 rounded-lg bg-gradient-to-r ${typeStyles[insight.type]} border transition-all duration-200 hover:scale-105 cursor-pointer group`}
            >
              <div className="flex items-start space-x-3">
                <Icon className={`w-5 h-5 mt-0.5 ${typeStyles[insight.type].split(' ')[3]}`} />
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-semibold text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-slate-300 transition-all duration-300">
                    {insight.title}
                  </h4>
                  <p className="text-xs text-slate-300 mt-1 leading-relaxed">
                    {insight.description}
                  </p>
                  <div className="mt-2">
                    <span className={`text-xs font-medium px-2 py-1 rounded-full bg-slate-800/50 ${typeStyles[insight.type].split(' ')[3]}`}>
                      {insight.impact}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <button className="w-full mt-6 bg-gradient-to-r from-purple-600 to-purple-500 text-white px-4 py-3 rounded-lg font-medium text-sm hover:from-purple-500 hover:to-purple-400 transition-all duration-200 hover:shadow-lg hover:shadow-purple-500/25 hover:scale-105 group">
        <div className="flex items-center justify-center space-x-2">
          <Target className="w-4 h-4 group-hover:rotate-12 transition-transform duration-200" />
          <span>Näytä kaikki</span>
        </div>
      </button>
    </div>
  );
}
